var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.bannerList.length > 0
    ? _c(
        "div",
        [
          _vm.bannerList.length > 1
            ? _c(
                "a-carousel",
                {
                  attrs: {
                    "after-change": _vm.onChange,
                    autoplay: _vm.flagCarousel
                  }
                },
                _vm._l(_vm.bannerList, function(item) {
                  return _c("div", { key: item.adId }, [
                    item.url
                      ? _c(
                          "a",
                          { attrs: { target: "_blank", href: item.url } },
                          [
                            _c("div", {
                              staticClass: "index-banner-bg",
                              style: {
                                "background-image": "url(" + item.picPath + ")",
                                "min-height": _vm.height + "px"
                              }
                            })
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "index-banner-bg",
                      style: {
                        "background-image": "url(" + item.picPath + ")",
                        "min-height": _vm.height + "px"
                      }
                    })
                  ])
                }),
                0
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.bannerList.length === 1
            ? [
                _vm.bannerList[0].url
                  ? _c(
                      "a",
                      {
                        attrs: { target: "_blank", href: _vm.bannerList[0].url }
                      },
                      [
                        _c("img", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            src: _vm.bannerList[0].picPath,
                            alt: _vm.bannerList[0].name
                          }
                        })
                      ]
                    )
                  : _c("img", {
                      staticStyle: { width: "100%" },
                      attrs: {
                        src: _vm.bannerList[0].picPath,
                        alt: _vm.bannerList[0].name
                      }
                    })
              ]
            : _vm._e()
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ccd374be", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ccd374be","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/IndexBanner/index.vue
// module id = null
// module chunks = 